import { useEffect } from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { SignUpHeader } from '@hotjar/webapp/components/SignUpHeader';
import { useUIState } from '@hotjar/webapp/features/Core/hooks/useUIState';
import { useWindowTitleWithBlur } from '@hotjar/webapp/hooks/useWindowTitle';
import { JoinOrganizationModal } from './components';
import { useOnboarding } from './hooks/useOnboarding';
import { Wrapper, Content, StyledLoader } from './styles';
import { OrganizationSteps } from './steps/OrganizationSteps';

const StyledWrapper = styled(Wrapper)`
  background-color: ${tokens.color.neutral_100};
`;

export function OnboardingPage(): React.ReactElement {
  const { onboard, user, isLoading, isOnboarding } = useOnboarding();
  const { setIsAppInterfaceVisible } = useUIState();
  const title = 'Create your Hotjar account';

  useWindowTitleWithBlur(title, title);

  useEffect(() => {
    setIsAppInterfaceVisible(false);
  }, [setIsAppInterfaceVisible]);

  return (
    <StyledWrapper>
      {isLoading || !user?.id ? (
        <StyledLoader size="xl" />
      ) : (
        <>
          <SignUpHeader user={user} />
          <Content>
            <OrganizationSteps
              userId={user.id}
              isSubmitInProgress={isOnboarding}
              onSubmit={onboard}
            />
            <JoinOrganizationModal />
          </Content>
        </>
      )}
    </StyledWrapper>
  );
}
